import LeaveFeedback from '@components/Feedback/LeaveFeedback.component';
import ReusableModal from '@components/Modal/ReusableModal.component';
import { Box, Typography } from '@mui/material'
import { styled } from '@mui/system';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useParams } from '@tanstack/react-router'
import axios from 'axios';
import { useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { RadioButtonUncheckedOutlined } from '@mui/icons-material';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';

export const Route = createFileRoute(
  '/(dashboard)/_dashboard/history-category-detail/$interviewId/$categoryId',
)({
  component: RouteComponent,
})


const StyledQuestion = styled(Box)(() => ({
    borderRadius: '12px',
    background: '#FFFFFF',
    border: '1px solid #F0F1F3',
    padding: '24px',
    boxShadow: '0px 1px 2px 0px #0205111A',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    cursor: 'pointer',
    width: '100%'
}))


const StyledAnswer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'isCorrect' && prop !== 'isPicked'
})<{ isCorrect?: boolean; isPicked?: boolean }>(({ isCorrect, isPicked }) => ({
    padding: '16px',
    borderRadius: '12px',
    border: '1px solid',
    borderColor: isCorrect ? 'var(--Interviewer-Green)' : isPicked ? 'var(--Red-Error-Color)' : 'var(--Light-Gray)',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    boxShadow: '0px 1px 2px 0px #0205111A'
}));

function RouteComponent() {

  const { interviewId, categoryId } = useParams({
    from: '/(dashboard)/_dashboard/history-category-detail/$interviewId/$categoryId',
  })

  const [openModal, setOpenModal] = useState(false)
  const handleClose = () => {
    setOpenModal(false)
  }
  const [openFeedback, setOpenFeedback] = useState(false)
  const [selectedQuestionId, setSelectedQuestionId] = useState(0)

  const { data, isLoading, error } = useQuery({
    queryKey: ['category-detail', interviewId, categoryId],
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `https://interviewer.runasp.net/api/submittedInterviews/${interviewId}/submittedCategories/${categoryId}/submittedQuestions`,
        {
          headers: {
              Authorization: `Bearer ${token}`,
          },
        }
      )
      return response.data
    },
  })


  //Question Modal
    const { data: questionDetail, isLoading: isLoadingQuestionDetail } = useQuery({
      queryKey: ['questionDetail'],
      queryFn: async () => {
        const token = localStorage.getItem('token');
        const response = await axios.get(
          `https://interviewer.runasp.net/api/submittedInterviews/${interviewId}/submittedCategories/${categoryId}/submittedQuestions/${selectedQuestionId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        return response.data
      },
      enabled: openModal
    });


  const openQuestionModal = (id: number) => {
    setOpenModal(true);
    setSelectedQuestionId(id)
  }

  //End Question Modal

  return (
    <Box sx={{
      padding: {xs: '20px 16px', md: '75px 75px'}
    }}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
      }}>
        {data?.map((question: object, index: number) => (
          <Box 
            key={question?.id}
            sx={{
              backgroundColor: '#fff',
              borderBottom: '1px solid var(--Interviewer-Near-White)',
              padding: '24px',
              boxShadow: '0px 1px 2px 0px #0205111A;',
              borderRadius: '12px'
            }}
            >
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px'
              }}>
                <Typography sx={{fontWeight: '700', fontSize: '16px', color: 'var(--Interviewer-Black)'}}>Question {index + 1}</Typography>
                <Typography sx={{fontWeight: '600', fontSize: '14px', color: 'var(--Interviewer-Lighter-Black)'}}>{question?.text}</Typography>
                <Typography 
                  onClick={() => openQuestionModal(question.id)} 
                  sx={{fontWeight: '500', fontSize: '14px', color: 'var(--Interviewer-Green)',width: 'fit-content', '&:hover': {cursor: 'pointer'}}}>
                    Go to question
                </Typography>
              </Box>
          </Box>
        ))}
      </Box>

      <ReusableModal open={openModal} onClose={handleClose}>
            <Typography variant="h1" sx={{ 
                fontSize: { xs: '18px', md: '24px' }
            }}>Question 1</Typography>
            {isLoadingQuestionDetail ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: '32px', outline: 'none', '&:focus': { outline: 'none'} }}>
                    <Typography>Loading question details...</Typography>
                </Box>
            ) : (
                <>
                    <Typography sx={{
                        mt: '14px',
                        fontSize: '14px'
                    }}>
                        {questionDetail?.text}
                    </Typography>
                    <Box sx={{display: 'flex', flexDirection: 'column', gap: '16px', mt: '32px'}}>
                        {questionDetail?.comparationAnswers?.map((answer, index) => (
                            <StyledAnswer 
                                key={index}
                                isCorrect={answer.isCorrect}
                                isPicked={answer.isPicked}
                            >
                                {answer.isCorrect ? (
                                    <CheckCircleIcon fontSize="small" sx={{ color: 'var(--Interviewer-Green)' }} />
                                ) : answer.isPicked ? (
                                    <CancelIcon fontSize="small" sx={{ color: 'var(--Red-Error-Color)' }} />
                                ) : (
                                    <RadioButtonUncheckedOutlined sx={{ color: 'var(--Light-Gray)' }} />
                                )}
                                <Typography sx={{ 
                                    fontSize: '14px'
                                }}>
                                    {answer.answer}
                                </Typography>
                            </StyledAnswer>
                        ))}
                    </Box>
                    <Box
                        onClick={() => setOpenFeedback(true)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            color: 'var(--Interviewer-Green)',
                            justifyContent: 'center',
                            mt: '24px',
                            '&:hover': {
                                opacity: 0.8,
                                cursor: 'pointer'
                            },
                        }}>
                        <Typography sx={{ 
                            textAlign: 'center', 
                            color: 'var(--Interviewer-Green)',
                            fontSize: '14px'
                        }}>Leave feedback for this question</Typography>
                        <ChevronRightOutlinedIcon />
                    </Box>
                </>
            )}
      </ReusableModal>

      <LeaveFeedback
          endpoint='https://interviewer.runasp.net/api/submittedInterviews'
          interviewId={`${interviewId}/submittedCategories/${categoryId}/submittedQuestions/${selectedQuestionId}`}
          open={openFeedback} 
          onClose={() => setOpenFeedback(false)}
          onSubmit={(data) => console.log('Feedback submitted:', data)}
      />
    </Box>
  )
}
